import axios from '../../../axios';
import { IInvoiceType } from '../types/IInvoiceType';

const url = '/invoicingservice/api/invoice-type';

export const createInvoiceType = (invoiceType: IInvoiceType) => axios.post(url, invoiceType);

export const updateInvoiceType = (invoiceType: IInvoiceType) =>
  axios.put(url, invoiceType).then((res) => res.data);

export const getAllInvoiceTypes = () => axios.get(url).then((res) => res.data);

export const getInvoiceNumber = (invoiceTypeId: string, clientId: string) =>
  axios.get(`${url}/invoice-number?invoiceTypeId=${invoiceTypeId}&clientId=${clientId}`);

export const updateInvoiceTypeDefault = (id: string) => axios.post(`${url}/update-default/${id}`);

export const getDefaultInvoiceType = () => axios.get(`${url}/default`);
